import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from '../../images/zsofi_es_peti_header_one.webp'
import hero2 from '../../images/zsofi_es_peti_header_two.webp'
import TimeCountDown from "../countdown";
import { useLanguage } from "../../contexts/LanguageContext";



class Hero5Inner extends Component {
    render() {

        var settings = {
            dots: false,
            arrows: true,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            fade: true
        };

        const { t } = this.props;

        return (
            <section className="wpo-hero-slider wpo-hero-style-3">
                <div className="wedding-announcement">
                    <div className="couple-text">
                        <h2 className="slideInUp">{t('hero.saveTheDate')}</h2>
                        <p className="slideInUp">{t('hero.gettingMarried')}</p>
                        <TimeCountDown/>
                    </div>
                </div>
                <div className="swiper-container">
                    <div className="swiper-wrapper">
                        <Slider {...settings}>
                            <div className="hero-slide">
                                <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero1})` }}>
                                </div>
                            </div>
                            <div className="hero-slide">
                                <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero2})` }}>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>
        )
    }
}

const Hero5 = () => {
    const { t } = useLanguage();
    return <Hero5Inner t={t} />;
};

export default Hero5;